import { create } from 'zustand';
import { db } from '../lib/database';
import { Employee } from '../types';

interface EmployeeState {
  employees: Employee[];
  isLoading: boolean;
  error: string | null;
  fetchEmployees: () => Promise<void>;
  getEmployeeById: (id: string) => Employee | undefined;
  getEmployeesByIds: (ids: string[]) => Employee[];
  getWorkers: () => Employee[];
}

export const useEmployeeStore = create<EmployeeState>((set, get) => ({
  employees: [],
  isLoading: false,
  error: null,
  
  fetchEmployees: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await db.getEmployees();

      const employees: Employee[] = data.map((emp: any) => ({
        id: emp.id,
        name: emp.name,
        email: emp.email,
        position: emp.position,
        role: emp.role as any
      }));

      set({ employees, isLoading: false });
    } catch (error) {
      console.error('Error fetching employees:', error);
      set({ error: "Failed to fetch employees", isLoading: false });
    }
  },
  
  getEmployeeById: (id: string) => {
    return get().employees.find(employee => employee.id === id);
  },
  
  getEmployeesByIds: (ids: string[]) => {
    return get().employees.filter(employee => ids.includes(employee.id));
  },
  
  getWorkers: () => {
    return get().employees.filter(employee => employee.role !== 'admin');
  }
}));